const Error404 = () => (
  <div>
    <h1>The Page you are looking for doesn't exit..</h1>
  </div>
)

export default Error404;